import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const highlightCardDefaultVariants = {}
const highlightCardCompoundVariants = []

const highlightCardSlotNames = [
  [
    "root",
    "highlight-card__root"
  ],
  [
    "contentWrapper",
    "highlight-card__contentWrapper"
  ],
  [
    "title",
    "highlight-card__title"
  ],
  [
    "description",
    "highlight-card__description"
  ],
  [
    "ctaDescription",
    "highlight-card__ctaDescription"
  ],
  [
    "ctaWrapper",
    "highlight-card__ctaWrapper"
  ]
]
const highlightCardSlotFns = /* @__PURE__ */ highlightCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, highlightCardDefaultVariants, getSlotCompoundVariant(highlightCardCompoundVariants, slotName))])

const highlightCardFn = memo((props = {}) => {
  return Object.fromEntries(highlightCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const highlightCardVariantKeys = []
const getVariantProps = (variants) => ({ ...highlightCardDefaultVariants, ...compact(variants) })

export const highlightCard = /* @__PURE__ */ Object.assign(highlightCardFn, {
  __recipe__: false,
  __name__: 'highlightCard',
  raw: (props) => props,
  variantKeys: highlightCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, highlightCardVariantKeys)
  },
  getVariantProps
})